import { ConversationFiltersButton } from "../ConversationFilters/styles";
import useArchiveConversation from "./use-archive-conversation";
import { Tooltip } from "react-tooltip";

const Archive = () => {
	const archiveConversation = useArchiveConversation();
	return (
		<>
			<ConversationFiltersButton
				data-tooltip-id="archive-tooltip"
				data-tooltip-content="Archive"
				style={{ float: "right" }}
				icon="fas fa-archive"
				onClick={archiveConversation}
			/>
			<Tooltip id="archive-tooltip" place="top" />
		</>
	);
};

export default Archive;
